<template>
  <div class="admin">
    


    <div v-show="this.isApp == false ? false : true" class="main-h5">
      <div class="main_content-h5">
        <div class="navigation">{{ $t("teaching.home") }} >></div>
        <div class="main-bod">
          <div class="title-con">
            <div
              @click="changeTilte(item, index)"
              :class="cieTitle == index ? 'title-item-sub' : 'title-item'"
              v-for="(item, index) in titleList"
              :key="index"
            >
              <div>{{ item.title }}</div>
            </div>
          </div>
          <div class="exchange-con" v-show="isTitle1">
            <div class="select">{{ $t("gift.t16") }}</div>
            <div class="exchange-med">
              <div
                @click="changeExchange(item, index)"
                class="exchange-med-item"
                v-for="(item, index) in exchangeList"
                :key="index"
              >
                <img
                  :class="
                    cieExchange == index
                      ? 'exchange-med-img-sub'
                      : 'exchange-med-img'
                  "
                  :src="item.ico"
                  alt=""
                />
              </div>
            </div>
            <div v-show="isExchange">
              <div class="exchange-tip">
                <div class="exchange-tip-item">{{ $t("gift.t3") }}</div>
                <div class="exchange-tip-item">{{ $t("gift.t4") }}</div>
                <div class="exchange-tip-item">{{ $t("gift.t5") }}</div>
              </div>
              <div class="line"></div>
              <div class="">
                <div class="exchange-tip-item">{{ $t("gift.t6") }}</div>
                <div class="ipt-wid-h5">
                  <input type="text" v-model="isCoin" :placeholder="this.minPrice" />
                  <!-- <input type="text" :placeholder="this.minPrice" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"> -->
                </div>
                <div class="amount-con"><span>{{$t("gift.t17")}}</span><span class="gift-amount">{{isAct}}</span></div>
              </div>
              <div class="bank-item-gift">
                <div class="bank-item-left">{{ $t("gift.t12") }}</div>
                <div class="bank-item-right">{{ bankName }}</div>
              </div>
              <div class="bank-item-gift">
                <div class="bank-item-left">{{ $t("gift.t13") }}</div>
                <div class="bank-item-right">
                  {{ bankDetail.BankAccountName }}
                </div>
              </div>
              <div class="bank-item-gift">
                <div class="bank-item-left">{{ $t("gift.t14") }}</div>
                <div class="bank-item-right">{{ bankDetail.PhoneNum }}</div>
              </div>
              <div class="bank-item-gift">
                <div class="bank-item-left">{{ $t("gift.t15") }}</div>
                <div class="bank-item-right">
                  {{ bankAct }}
                </div>
              </div>
              <div class="submit-con">
                <div class="submit" @click="submitExtractInfo">{{ $t("gift.t10") }}</div>
              </div>
            </div>
          </div>
          <Record v-show="isTitle2" ref="child"></Record>
        </div>
      </div>
    </div>



  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.admin {
  width: 100%;
  height: 100vh;
  background: rgb(248, 248, 248);
  position: relative;
  .loginMode {
    width: 400px;
    height: 350px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    .loginTitle {
      width: 400px;
      height: 100px;
      line-height: 100px;
      font-size: 30px;
      background: rgb(182, 233, 107);
      color: white;
    }
    .loginNum,
    .loginPass {
      width: 400px;
      height: 50px;
      padding-top: 10px;
      input {
        border: 2px solid rgb(182, 233, 107);
        background: rgb(248, 248, 248);
        width: 400px;
        height: 50px;
        padding-left: 20px;
        padding-right: 20px;
      }
    }
    .goLogin {
      width: 400px;
      height: 60px;
      padding-top: 10px;
      button {
        width: 400px;
        height: 50px;
        background: rgb(182, 233, 107);
        color: white;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
}
</style>